import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "custom-field-line" }
const _hoisted_2 = {
  key: 0,
  class: "order-name"
}
const _hoisted_3 = { class: "order-value" }
const _hoisted_4 = { class: "quick-order-main" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "quick-order-information" }
const _hoisted_7 = { class: "quick-order-title" }
const _hoisted_8 = { class: "quick-order-description-block" }
const _hoisted_9 = { class: "quick-order-description" }
const _hoisted_10 = { class: "custom-field-line" }
const _hoisted_11 = {
  key: 0,
  class: "order-name"
}
const _hoisted_12 = { class: "order-value" }

import vue from '../../../../adapter-vue';
import { TUITranslateService } from '../../../../@aidesk/uikit-engine';
import cardToolbarCloseIcon from '../../../../assets/dialog-close.png';
import Icon from '../../../common/Icon.vue';
import { QuickOrderModel } from '../../../../interface';
import { isPC } from '../../../../utils/env';
interface IProps {
  bottomQuickOrder: QuickOrderModel;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    bottomQuickOrder: { default: () => ({} as QuickOrderModel) }
  },
  emits: ['closeOrder','sendOrder'],
  setup(__props: any, { emit: __emit }) {

const { computed } = vue;
const emits = __emit;

const props = __props;

const customField = computed(() => {
  return Array.isArray(props.bottomQuickOrder?.customField) ? props.bottomQuickOrder.customField : [];
}); 

const topCustomField = computed(() => {
  return customField.value.filter((item) => item.position === 'top');
});

const bottomCustomField = computed(() => {
  return customField.value.filter((item) => item.position !== 'top'); 
});

const sendOrder = () => {
  emits('sendOrder');
};

const closeOrder = () => {
  emits('closeOrder');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(isPC) ? 'bottom-quick-order-line':'')
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['bottom-quick-order-container',_unref(isPC) && 'bottom-quick-order-container-pc'])
    }, [
      _createElementVNode("div", { onClick: closeOrder }, [
        _createVNode(Icon, {
          class: "close-icon",
          file: _unref(cardToolbarCloseIcon),
          width: "12px",
          height: "12px"
        }, null, 8, ["file"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(topCustomField), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "quick-order-custom-field"
        }, [
          _createElementVNode("div", _hoisted_1, [
            (item.name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(item.name) + ": ", 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, _toDisplayString(item.value), 1)
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_4, [
        (props.bottomQuickOrder.pic)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "quick-order-img",
              src: props.bottomQuickOrder.pic
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(props.bottomQuickOrder.header), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(props.bottomQuickOrder.desc), 1),
            (_unref(bottomCustomField).length === 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "quick-order-link",
                  onClick: sendOrder
                }, _toDisplayString(_unref(TUITranslateService).t("发送")), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bottomCustomField), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "quick-order-custom-field"
        }, [
          _createElementVNode("div", _hoisted_10, [
            (item.name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(item.name) + ": ", 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, _toDisplayString(item.value), 1)
          ])
        ]))
      }), 128)),
      (_unref(bottomCustomField).length !== 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "quick-order-link",
            onClick: sendOrder
          }, _toDisplayString(_unref(TUITranslateService).t("发送")), 1))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})